import { useEffect } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useLanguage } from '@/hooks/useLanguage';
import SEO from '@/components/SEO';
import ScrollToTop from '@/components/ScrollToTop';

const JOTFORM_ID = '230534941012041';

const Booking = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
    script.async = true;
    script.onload = () => {
      if ((window as any).jotformEmbedHandler) {
        (window as any).jotformEmbedHandler(
          `iframe[id='JotFormIFrame-${JOTFORM_ID}']`,
          'https://pci.jotform.com/'
        );
      }
    };
    document.body.appendChild(script);
    return () => { script.remove(); };
  }, []);

  return (
    <>
      <SEO
        title={t('booking.title')}
        description={t('booking.subtitle')}
      />
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        <main className="flex-1">
          <section className="relative py-12 md:py-20 bg-gradient-hero text-primary-foreground">
            <div className="container mx-auto px-4">
              <div className="max-w-4xl mx-auto text-center">
                <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6">
                  {t('booking.title')}
                </h1>
                <p className="text-lg md:text-xl opacity-95 mb-4">
                  {t('booking.subtitle')}
                </p>
              </div>
            </div>
          </section>

          <section className="py-8 md:py-16 bg-background">
            <div className="container mx-auto px-4">
              <div className="max-w-5xl mx-auto">
                <iframe
                  id={`JotFormIFrame-${JOTFORM_ID}`}
                  title="1 - Main Intake Form payment Process Multilingual"
                  onLoad={() => window.scrollTo(0, 0)}
                  allowTransparency={true}
                  allow="geolocation; microphone; camera; fullscreen; payment"
                  src={`https://pci.jotform.com/form/${JOTFORM_ID}`}
                  frameBorder={0}
                  style={{ minWidth: '100%', maxWidth: '100%', height: '539px', border: 'none' }}
                  scrolling="no"
                />
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Booking;
